<template>
  <div class="upper-line" style="z-index: 666">
    <div :id="lineId" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {debounce} from "../../utils/util";

  export default {
    name: 'upper-line',
    props: {
      lineId: {
        type: String,
        default () {
          return 'upperLineId'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '240px'
        }
      },
      lineTitle: {
        type: String,
        default () {
          return ''
        }
      },
      titleStyle: {
        type: Object,
        default () {
          return  {}
        }
      },
      colorList: {
        type: Array,
        default () {
          return ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC']
        }
      },
      legendData: {
        type: Array,
        default () {
          return []
        }
      },
      xAxis: {
        type: Object,
        default () {
          return  {}
        }
      },
      yAxis: {
        type: Array,
        default () {
          return []
        }
      },
      series: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        upperLine: null
      }
    },
    mounted () {
      this.drawLine()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      drawLine() {
        this.upperLine = this.$echarts.init(document.getElementById(this.lineId))
        this.upperLine.setOption({
          title: {
            text: this.lineTitle,
            textStyle: this.titleStyle
          },
          tooltip : {
            order: 'seriesAsc',
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
          },
          legend: {
            order: 'seriesDesc',
            textStyle: {
              color: '#ffffff'
            },
            right: '4%',
            data: this.legendData
          },
          // color: ['#92D050', '#FFC000'],
          grid: {
            left: '3%',
            right: '5%',
            top: '25%',
            bottom: '0',
            containLabel: true
          },
          color: this.colorList,
          xAxis: this.xAxis,
          yAxis: this.yAxis,
          series: this.series
        })
      },
      resizeChart: debounce(function () {
        this.upperLine.resize()
      }, 100)
    },
    watch: {
      series (val) {
        this.drawLine()
      }
    }
  }
</script>

<style scoped>
  .upper-line {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/UpperEcharts/upperLine.vue